module.exports = __webpack_public_path__ + "static/media/xml.a03b766e.png";